import { Component } from '@angular/core';
import { TestDynamicComponent, TestDynamicType } from '../../common/test-dynamic/test-dynamic.component';

@Component({
  selector: 'app-option-mapping',
  templateUrl: '../../common/test-dynamic/test-dynamic.component.html',
  styleUrls: ['../../common/test-dynamic/test-dynamic.component.css']
})
export class OptionMappingComponent extends TestDynamicComponent {

  getTestDynamicType(): TestDynamicType {
    return TestDynamicType.OPTIONS;
  }

  getTitle(): string {
    return 'Test mapping rules';
  }

  getSubmitLabel(): string {
    return 'Test';
  }


}
